import React, { useMemo } from "react"
import { GenericTable } from "../GenericTable"

export const CMOSLive = ({ translations, summaryData: data, toggle }) => {
  const rows = useMemo(() => {
    return [
      [translations['CL_VOA_BA_Reference'], 'CMOS_VOA'],
      [translations['VOA_Reason_Code'], 'CMOS_VOA_Reason_Code'],
      [translations['CL_UPRN'], 'CMOS_UPRN'],
      [translations['UPRN_Reason_Code'], 'CMOS_UPRN_Reason_Code'],
      [translations['CL_Free_Descriptor'], 'CMOS_Free_Descriptor'],
      [translations['Occupier'], 'Customer_Name'],
      [translations['CL_Secondary_Addressable_Object'], 'CMOS_Secondary_Addressable_Object'],
      [translations['CL_Primary_Addressable_Object'], 'CMOS_Primary_Addressable_Object'],
      [translations['CL_Address_Line_1'], 'CMOS_Address_Line_1'],
      [translations['CL_Address_Line_2'], 'CMOS_Address_Line_2'],
      [translations['CL_Address_Line_3'], 'CMOS_Address_Line_3'],
      [translations['CL_Address_Line_4'], 'CMOS_Address_Line_4'],
      [translations['CL_Address_Line_5'], 'CMOS_Address_Line_5'],
      [translations['CL_Postcode'], 'CMOS_Postcode'],
      ['CMOS_Free_Descriptor']
    ]
  }, [translations])
  return (
    <div>
      <GenericTable title={translations['Current_CMOS_Premises_Header']} rows={rows} data={data} toggle={toggle} />
    </div>
  )
}
